// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Leave defaults so this still works in developers local environments.
  ['apiEndpoint']: 'https://wldmgr-api-dev.azure.chevron.com',
  ['apiEndpointQMDB']: 'https://qmdb-api-dev.azure.chevron.com',
  // app insights
  appInsights: {
    connectionString:
      'InstrumentationKey=8e1b9395-fd35-4d3c-91a5-632b72d1e941;IngestionEndpoint=https://southcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=53d434e5-b49b-4e57-a261-dd1482e44158'
  },
  host: {
    localhost: 'localhost',
    dev: 'wldmgr-dev.azure.chevron.com',
    test: 'wldmgr-test.azure.chevron.com'
  },
  supportLink:
    'https://chevron.service-now.com/itserviceportal?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=5054022'
};

